import api from "./Api";
import {
  dismissToast,
  showError,
  showLoading,
  showSuccess,
} from "../components/Ui/ToastNotification";

export const getDashboardImages = async (
  page = 1,
  limit = 10,
  userEmail = null
) => {
  const loadingToastId = showLoading("Fetching dashboard images...");

  try {
    const response = await api.get("/dashboard-image", {
      params: { page, limit },
    });

    dismissToast(loadingToastId);
    return {
      dashboardImages: response.data.dashboardImages,
      pagination: response.data.pagination,
    };
  } catch (error) {
    dismissToast(loadingToastId);
    showError("Failed to fetch dashboard images");
    console.error("Get dashboard images failed:", error);
    throw error;
  }
};

export const getDashboardImageById = async (dashboardImageId) => {
  const loadingToastId = showLoading("Fetching dashboard image...");

  try {
    const response = await api.get(`/dashboard-image/${dashboardImageId}`);

    dismissToast(loadingToastId);
    return response.data.dashboardImage;
  } catch (error) {
    dismissToast(loadingToastId);
    showError("Failed to fetch dashboard image");
    console.error("Get dashboard image failed:", error);
    throw error;
  }
};

export const createDashboardImage = async (data) => {
  const { title, description, imageUrl } = data;
  const loadingToastId = showLoading("Creating dashboard image...");

  try {
    const response = await api.post("/dashboard-image", {
      title,
      description,
      imageUrl,
    });

    dismissToast(loadingToastId);
    showSuccess(
      response.data.message || "Dashboard image created successfully!"
    );
    return response.data;
  } catch (error) {
    dismissToast(loadingToastId);
    showError(
      error.response?.data?.message || "Failed to create dashboard image"
    );
    console.error("Create dashboard image failed:", error);
    throw error;
  }
};

export const updateDashboardImage = async (dashboardImageId, updateData) => {
  const loadingToastId = showLoading("Updating dashboard image...");

  try {
    const response = await api.patch(`/dashboard-image/${dashboardImageId}`, {
      title: updateData.title,
      description: updateData.description,
      imageUrl: updateData.imageUrl,
    });

    dismissToast(loadingToastId);
    showSuccess(
      response.data.message || "Dashboard image updated successfully!"
    );
    return response.data;
  } catch (error) {
    dismissToast(loadingToastId);
    showError(
      error.response?.data?.message || "Failed to update dashboard image"
    );
    console.error("Update dashboard image failed:", error);
    throw error;
  }
};

export const uploadFile = async (file, userEmail) => {
  if (!userEmail) {
    throw new Error("User email is required for file upload");
  }

  const formData = new FormData();
  formData.append("file", file);

  try {
    const response = await api.post(`/upload/file/${userEmail}`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    return response.data;
  } catch (error) {
    console.error("File upload error:", error);
    throw error;
  }
};

export const deleteDashboardImage = async (dashboardImageId) => {
  const loadingToastId = showLoading("Deleting dashboard image...");

  try {
    const response = await api.delete(`/dashboard-image/${dashboardImageId}`);

    dismissToast(loadingToastId);
    showSuccess(
      response.data.message || "Dashboard image deleted successfully!"
    );
    return response.data;
  } catch (error) {
    dismissToast(loadingToastId);
    showError("Failed to delete dashboard image");
    console.error("Delete dashboard image failed:", error);
    throw error;
  }
};
